import { connect } from 'react-redux';
import {
  getDisabledDays,
  getIsDisabled,
  getAvailableTimes,
  setTime,
  getTime,
  getMode,
  getDate,
  setMode,
  getActualTime,
  dateModes,
  timeTranslation,
} from '../../features/commerce/delivery/dates';
import { getItem } from '../../features/commerce';
import { getMoms } from '../../features/commerce/moms';
import { sanitizePrice } from '../../lib/price';
import { getDeliveryType } from '../../features/commerce/delivery';
import { getErrorIfShow } from '../../features/form-error/selectors';
import { validateFieldRequest } from '../../features/form-error/actions';

export default deliveryType => dateType => connect(
  (state) => {
    const date = getDate(deliveryType)(dateType)(state);
    const moms = getMoms(state);
    return {
      disabled:
        getDeliveryType(state) !== deliveryType
        || getIsDisabled(deliveryType)(dateType)(state)
        || getMode(deliveryType)(dateType)(state) === dateModes.none
        || !date,
      disabledDays: getDisabledDays(deliveryType)(dateType)(state),
      choices: getAvailableTimes(deliveryType)(dateType)(state),
      getTimeFee: (time) => {
        const {
          varenr,
          shortTime,
          amount,
          removeFee,
        } = timeTranslation[time];
        if (removeFee && removeFee(date)) {
          return `${shortTime}`;
        }
        const {
          values: {
            price,
          },
        } = getItem(state, { varenr });
        const momsMultiplier = moms ? 1 : 0.8;
        const sanPrice = Math.round(sanitizePrice(price) * amount * momsMultiplier);
        let decimal = `${sanPrice % 100}`;
        if (decimal.length === 1) {
          decimal = `0${decimal}`;
        }
        // return `${shortTime} | +${Math.floor(sanPrice / 100)},${decimal},-`;
        return `${shortTime} | +${Math.floor(sanPrice / 100)} kr.`;
      },
      date,
      mode: !getDate(deliveryType)(dateType)(state) ? dateModes.none : getMode(deliveryType)(dateType)(state),
      error: getErrorIfShow(state, { container: 'delivery', field: dateType }),
      value: getTime(deliveryType)(dateType)(state),
      actualTime: getActualTime(deliveryType)(dateType)(state),
      dateType,
    };
  },
  dispatch => ({
    onChoose: (date) => {
      dispatch(setTime(deliveryType)(dateType)(date));
      dispatch(validateFieldRequest({ container: 'delivery', dateType }));
    },
    onChangeMode: (mode) => {
      dispatch(setMode(deliveryType)(dateType)(mode));
      dispatch(validateFieldRequest({ container: 'delivery', dateType }));
    },
  }),
);
